import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Alert } from 'react-bootstrap';
import { getStatusModalCloseSite } from '~/services/comment';

export default function TopRightPopup({ currentLang, profile }) {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  // const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (currentLang !== 'en') {
      try {
        getStatusModalCloseSite().then((response) => {
          if (response.modal_integration) {
            setShow(true);
          } else {
            const isShowPopup = localStorage.getItem(
              'isShowModalOutSideTaiwan',
            );
            if (!isShowPopup) {
              setShow(true);
            }
          }
        });
      } catch (error) {
        console.log('vo day ne', error);
      }
    }
  }, [currentLang, profile]);

  const handleClose = () => {
    setShow(false);

    // if (checked) {
    //   getStatusModalCloseSite({
    //     modal_integration: 0,
    //     isUpdateStatus: true,
    //   });
    //   localStorage.setItem('isShowPopupSiteIntegration', 'false');
    // }
    getStatusModalCloseSite({
      modal_integration: 0,
      isUpdateStatus: true,
    });
    localStorage.setItem('isShowPopupSiteIntegration', 'false');
  };

  return (
    <>
      {show && (
        // <div className="popup-box">
        //   <div className="popup-content">
        //     <button className="close-btn" onClick={handleClose}>
        //       &times;
        //     </button>
        //     <p
        //       style={{
        //         fontSize: '14px',
        //         marginBottom: '0.5em',
        //         marginTop: '1em',
        //       }}
        //     >
        //       {t('english_site_integration')}
        //     </p>
        //     <div
        //       style={{
        //         display: 'flex',
        //         alignItems: 'center',
        //         justifyContent: 'center',
        //       }}
        //     >
        //       <input
        //         type="checkbox"
        //         style={{
        //           margin: 0,
        //           width: 16,
        //           height: 16,
        //           display: 'block',
        //         }}
        //         checked={checked}
        //         onChange={(e) => setChecked(e.target.checked)}
        //       />
        //       <small
        //         style={{
        //           padding: 0,
        //           marginLeft: 8,
        //         }}
        //       >
        //         {t('not_show_message')}
        //       </small>
        //     </div>
        //   </div>
        // </div>
        <Alert
          variant="info"
          style={{
            margin: 0,
          }}
        >
          <div
            style={{
              position: 'relative',
              height: '100%',
              textAlign: 'center',
            }}
          >
            {t('english_site_integration')}
            <button className="close-btn" onClick={handleClose}>
              &times;
            </button>
          </div>
        </Alert>
      )}

      <style jsx>{`
        .popup-box {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 999999999;
        }

        .popup-content {
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
          padding: 16px;
          width: 320px;
          font-size: 14px;
          position: relative;
        }

        .close-btn {
          position: absolute;
          top: 2px;
          right: 8px;
          background: transparent;
          border: none;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        }

        .close-btn:hover {
          opacity: 0.8;
        }
      `}</style>
    </>
  );
}
